export const createDelay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
